import { render } from "./userLogin.vue?vue&type=template&id=50981d46&scoped=true"
import script from "./userLogin.vue?vue&type=script&lang=js"
export * from "./userLogin.vue?vue&type=script&lang=js"

import "./userLogin.vue?vue&type=style&index=0&id=50981d46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50981d46"]])

export default __exports__